@if (sessionActive()) {
  <div class="screen-share-overlay">
    <div class="screen-share-toolbar">
      <span class="screen-share-label">Viewing screen share from {{ sharerEmail() }}</span>
      <button type="button" class="btn btn-sm btn-danger ms-3" (click)="stopSharing()">Stop Sharing</button>
    </div>
    <img [src]="frameSrc()" class="screen-share-frame" alt="Shared screen" />
  </div>
}
